"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = require("prop-types");

var _Button = _interopRequireDefault(require("../Button/Button"));

var _colors = _interopRequireDefault(require("../../constants/colors"));

var _spacing = _interopRequireDefault(require("../../constants/spacing"));

var _supportsStaticImport = _interopRequireDefault(require("./supportsStaticImport"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n\tposition: absolute;\n\ttop: 0;\n\tright: 0;\n\tfont-weight: bold;\n\tmargin: ", ";\n\tfont-size: 2rem;\n\tline-height: 1;\n\tfont-family: monospace;\n\tbackground: transparent;\n\tborder: none;\n\tcursor: pointer;\n\n\t&:hover {\n\t\tcolor: #fff;\n\t}\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\tposition: relative;\n\ttext-align: center;\n\tbackground-color: ", ";\n\tpadding: ", " ", ";\n\n\tp {\n\t\tmargin: 0;\n\t}\n\n\t", " {\n\t\tmargin-top: ", ";\n\t}\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

var Container = _styledComponents.default.div(_templateObject(), _colors.default.warning, _spacing.default.s2, _spacing.default.s6, _Button.default, _spacing.default.s2);

Container.displayName = 'Container';

var CloseBtn = _styledComponents.default.button(_templateObject2(), _spacing.default.s1);

CloseBtn.displayName = 'CloseBtn';

var BrowserWarning = function BrowserWarning(_ref) {
  var children = _ref.children,
      allowDismiss = _ref.allowDismiss;

  var _useState = (0, _react.useState)(false),
      showWarning = _useState[0],
      setShowWarning = _useState[1];

  (0, _react.useLayoutEffect)(function () {
    setShowWarning(window.sessionStorage.getItem('browser-warning-dismissed') ? false : !(0, _supportsStaticImport.default)());
  }, []);
  if (!showWarning) return null;
  return _react.default.createElement(Container, null, allowDismiss && _react.default.createElement(CloseBtn, {
    type: "button",
    "aria-label": "Dismiss",
    onClick: function onClick() {
      setShowWarning(false);
      window.sessionStorage.setItem('browser-warning-dismissed', true);
    }
  }, "\xD7"), children || _react.default.createElement("p", null, _react.default.createElement("strong", null, "Your browser is out of date."), " Please update your browser for more security, speed and the best experience on this site."), _react.default.createElement(_Button.default, {
    color: "primary",
    outline: true,
    as: "a",
    target: "_blank",
    rel: "noopener",
    href: "https://bestvpn.org/outdatedbrowser/en"
  }, "Update browser"));
};

BrowserWarning.defaultProps = {
  children: null,
  allowDismiss: true
};
BrowserWarning.propTypes = {
  children: _propTypes.node,
  allowDismiss: _propTypes.bool
};
var _default = BrowserWarning;
exports.default = _default;